export type PollingExperiment = {
  experimentName: string;
  pageName: string;
};

// active survey-thanks polling experiments: https://admin.surveymonkey.com/experiments/polling
// @todo: add device and experiment info to url  https://momentiveai.atlassian.net/browse/ANONWEB-5463
export const PollingExperiments: PollingExperiment[] = [
  {
    // https://admin.surveymonkey.com/experiments/polling/1075
    experimentName: 'national_survey_ctm_benchmark_v2',
    pageName: 'FeaturedEpUSMap',
  },
];
